import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { StateUseContext } from '../context/UserDetailContext';
import swal from 'sweetalert';
// import { salesforceSendFormNumber } from '../actions/StudentAction';
import Logo from '../assets/images/logo.png';
import queryString from 'query-string';

const MasterCardPaymentFailed = () => {

  const { userDetail } = StateUseContext();
  const [hasProcessedData, setHasProcessedData] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const qParams = useParams();
  const { form_num } = userDetail !== undefined && userDetail;
  const { userId } = qParams;

  useEffect(() => {
    if (userDetail !== undefined && !hasProcessedData) {
      // Convert userId to number for comparison (URL params are strings)
      if (userDetail.id === Number(userId)) {
        // Parse query params inside useEffect to avoid dependency issues
        const queryParam = queryString.parse(location.search);

        // Update Salesforce status to payment_rejected
        // if (form_num) {
        //   salesforceSendFormNumber({ form_num: form_num, status: 'payment_rejected' });
        // }

        // Determine the error message based on available information
        let errorMessage = 'Your payment was cancelled or failed.';
        const errorTitle = 'Payment Failed';

        // Check if location.search is empty or query params are empty
        // When user cancels, queryParam will be an empty object {} and location.search will be empty
        const hasQueryParams = location.search && location.search.trim() !== '' && Object.keys(queryParam).length > 0;

        if (hasQueryParams) {
          // There are query params, check for specific error messages
          if (queryParam.resultIndicator) {
            errorMessage = `Payment transaction was not completed. Transaction ID: ${queryParam.resultIndicator}`;
          }

          if (queryParam.reason) {
            errorMessage = queryParam.reason;
          }

          if (queryParam.responseMessage) {
            errorMessage = queryParam.responseMessage;
          }
        } else {
          // No query params means user likely cancelled or went back
          errorMessage = 'No payment was collected as part of this transaction. ';
        }

        // Show error alert
        swal({
          title: errorTitle,
          text: errorMessage + "Any amount debited will be refunded back to source based on Mastercard's policy. In case of any issue, please contact our support team.",
          icon: 'error',
          buttons: {
            retry: {
              text: 'Retry Payment',
              value: 'retry',
            },
            dashboard: {
              text: 'Go to Dashboard',
              value: 'dashboard',
            },
          },
        }).then((value) => {
          // Navigate to dashboard (both options go to dashboard for now)
          navigate('/student/dashboard');
        });

        setHasProcessedData(true);
      }
    }
  }, [userDetail, userId, hasProcessedData, form_num, navigate, location.search]);

  return (
    <div className="screenLoader text-center flex-wrap">
      <img src={Logo} alt="Processing..." style={{ width: '200px' }} />
      <span className="d-block w-100 fw-bold fs-6 text-center" style={{ marginTop: '-50px' }}>
        Processing payment status...
      </span>
    </div>
  );
};

export default MasterCardPaymentFailed;

